// extracted by mini-css-extract-plugin
export var activitiesContent = "Activities-module--activitiesContent--2b9b4";
export var containerSection = "Activities-module--containerSection--a9c2f";
export var containerStart = "Activities-module--containerStart--08af0";
export var contentOpenActivity = "Activities-module--contentOpenActivity--df260";
export var correction = "Activities-module--correction--d1d00";
export var descriptionActivities = "Activities-module--descriptionActivities--a9147";
export var flexWrapper = "Activities-module--flexWrapper--f8833";
export var listContainer = "Activities-module--listContainer--b682f";
export var subtitleH3Activities = "Activities-module--subtitleH3Activities--0739a";
export var titleH2Activities = "Activities-module--titleH2Activities--1e2c0";